import React from 'react'
import { withIcon } from '../../withIcon'

function ThumbUpSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M19.1824 20L10.7801 20C10.7143 20 10.6479 19.9933 10.5834 19.9797C8.1957 19.4746 8.68238 18.5262 8.68238 15.5V11.4289C8.68238 11.192 8.87448 11 9.11146 11C9.15842 11 9.20444 10.9925 9.24865 10.9767C9.52461 10.878 10.5953 10.477 11.1824 10C11.9401 9.38435 12.2695 8.88472 12.6824 8C12.8773 7.58233 13.1824 6.88071 13.1824 5.5C13.1824 4.37796 13.9783 4 14.6824 4C15.6824 4 16.2919 4.71895 16.6824 5.5C17.1017 6.33857 16.8177 8.23194 16.7152 10.0007C16.6832 10.5521 17.1291 10.9784 17.6799 10.9374C19.2239 10.8224 21.6824 10.697 21.6824 12C21.6824 13.6621 20.1824 20 19.1824 20Z" fill={color}/>
      <path d="M3 19.5C2.26598 19.5 1.95025 11.5 2.95032 11C3.87529 10.5375 5.32864 10.6874 6.20539 10.8415C6.64887 10.9195 6.95214 11.3121 6.95478 11.7624L6.99412 18.4942C6.99736 19.0487 6.54853 19.5 5.99396 19.5L3 19.5Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ThumbUpSolidIcon)
